module.exports = __webpack_public_path__ + "static/media/s_2_1.0a40f2c9.mp4";